export const TABLE_COLUMNS = ['member', 'views', 'files', 'manage'] as const;

export const COPY_HEADING_CELL = {
  member: 'name',
  views: 'views',
  files: 'files',
  manage: '',
};

export const SORTING_VALUES = {
  member: '',
  views: 'numberOfViewedFiles',
  files: 'numberOfAccessableFiles',
  manage: '',
};

export const POPUP_SORT_NAME: Record<string, string> = {
  numberOfAccessableFiles: 'numberOfAccessableFilesPopup',
};
